/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useImperativeHandle } from 'react';
import clsx from 'clsx';
import { AccordionDetails, AccordionSummary, Accordion } from '@mui/material';
import customStyles from "../../../../assets/styles/customStyles";
import AccordionIcon from "../Icons/AccordionIcon";
import { Waypoint } from 'react-waypoint';
import { handleHeight } from "../../../../helpers/utilities";

export const AccordionComponent = React.forwardRef((props, ref) => {
    const { title, component, handleAccordinClick } = props;
    const [expandedForm, setExpandedForm] = useState(title);

    const handleChange = (panel) => (event, newExpanded) => {
        setExpandedForm(newExpanded ? panel : false);
        setTimeout(() => {
            handleAccordinClick();
        }, 284);
    };

    const classes = customStyles();
    return (
        <Accordion
            ref={ref}
            className={clsx(classes.tableRoot)}
            expanded={expandedForm === title} onChange={handleChange(title)}>
            <AccordionSummary expandIcon={expandedForm === title ? <AccordionIcon /> : <AccordionIcon />}>{title}</AccordionSummary>
            <AccordionDetails>{component}</AccordionDetails>
        </Accordion>
    )
})

export const DeliveryAccordionComponent = React.forwardRef((props, ref) => {
    const { title, component, titleClasses, detailClasses, expand } = props;
    return (
        <Accordion
            ref={ref}
            defaultExpanded={expand || false}
            key={title}>
            <AccordionSummary key={title} className={titleClasses}>{title}</AccordionSummary>
            <AccordionDetails className={detailClasses}>{component}</AccordionDetails>
        </Accordion>
    )
})

export const CustomAccordion = React.forwardRef((props, ref) => {
    const { title, component, top = 0, showDetails, zIndex, topVisible, index, height } = props;
    const [visibleHeader, setVisibleHeader] = useState(false);
    //const [visibleLast, setVisibleLast] = useState(false);
    const [loader, setLoader] = useState(false);
    const componentRef = useRef();



    const handleClick = (e, index) => {
        let cH = 0;
        let el = document.getElementById('containerDiv');
        if (el) {
            let greyContents = document.querySelectorAll(`.${classes.customAccrodinContent}`);
            if (e.target.parentNode.classList.contains(`${classes.headerCollapse}`)) {
                greyContents.forEach(function (greyContent, i) {
                    if (parseInt(i) < parseInt(index)) {
                        cH += greyContent.offsetHeight;
                    }
                });
            } else {
                greyContents.forEach(function (greyContent, i) {
                    if (index >= i) {
                        cH += greyContent.offsetHeight;
                    }
                });
            }
            if (el.scrollTop + 7 >= (el.scrollHeight - el.offsetHeight)) {
                el.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: "smooth",
                });
            } else {
                el.scrollTo({
                    top: cH + 1,
                    left: 0,
                    behavior: "smooth",
                });
            }
        }
    }

    useImperativeHandle(ref, () => ({
        handleAdjustHeight() {
            customHandleHeight();
        }
    }));


    const customHandleHeight = () => {
        handleHeight(classes);
        setTimeout(() => {
            setLoader(true);
        }, 250)
    }

    // useEffect(() => {
    //     const scrollContent = document.getElementById('containerDiv'); // store in a variable so we can reference the element in multiple locations
    //     scrollContent.removeEventListener('scroll', runOnScroll(scrollContent));
    //     scrollContent.addEventListener('scroll', () => runOnScroll(scrollContent), { passive: true });
    //     return () => scrollContent.removeEventListener('scroll', runOnScroll(scrollContent));
    // }, []);

    // const runOnScroll = (el) => {
    //     if (el.scrollTop === (el.scrollHeight - el.offsetHeight)) {
    //         setVisibleLast(true);
    //     } else {
    //         setVisibleLast(false);
    //     }
    // }


    useEffect(() => {
        if (!showDetails) {
            customHandleHeight();
        }
    }, [showDetails]);

    const classes = customStyles();
    return (
        <React.Fragment>
            <div datatop={top} className={clsx(classes.customAccrodinHeader, { [classes.customAccrodinHeaderSingle]: height }, { [classes.headerCollapse]: visibleHeader })}
                style={{ top: top + 'px', zIndex: zIndex }}
                onClick={(e) => handleClick(e, index)}>
                <span className={classes.customZoom}>{title}</span>
            </div>
            <div ref={componentRef} className={clsx(classes.customAccrodinContent)} style={{ zIndex: zIndex - 1, height: height ? height : 'auto' }}>
                <Waypoint
                    onEnter={({ previousPosition, currentPosition, event }) => {
                        if (currentPosition === 'inside') {
                            if (loader && document.getElementById('containerDiv') && document.getElementById('containerDiv')?.parentElement) {
                                document.getElementById('containerDiv').parentElement.classList.add(classes.scrollBorder);
                            }
                        }
                    }}
                    onLeave={({ previousPosition, currentPosition, event }) => {
                        if (currentPosition === 'inside' || currentPosition === 'below') {
                            if (loader && document.getElementById('containerDiv') && document.getElementById('containerDiv')?.parentElement) {
                                document.getElementById('containerDiv').parentElement.classList.remove(classes.scrollBorder);
                            }
                        }
                    }}
                >
                </Waypoint>
                <div className={clsx(classes.customAccrodinContentInner, classes.customZoom, classes.closeBackGround)}>{component}</div>
                <Waypoint topOffset={topVisible} onEnter={({ previousPosition, currentPosition, event }) => {
                    if (loader && currentPosition === 'inside') {
                        setTimeout(function () {
                            setVisibleHeader(false);
                        }, 200);
                    }
                }}
                    onLeave={({ previousPosition, currentPosition, event }) => {
                        if (loader && currentPosition === 'above') {
                            setTimeout(function () {
                                setVisibleHeader(true);
                            }, 200)
                        }
                    }}>
                </Waypoint>
                {
                    <Waypoint
                        onEnter={({ previousPosition, currentPosition, event }) => {
                            if (currentPosition === 'inside') {
                                if (loader && document.getElementById('containerDiv') && document.getElementById('containerDiv')?.parentElement) {
                                    document.getElementById('containerDiv').parentElement.classList.remove(classes.scrollBorder);
                                }
                            }
                        }}
                        onLeave={({ previousPosition, currentPosition, event }) => {
                            if (currentPosition === 'below' || currentPosition === 'above') {
                                if (loader && document.getElementById('containerDiv') && document.getElementById('containerDiv')?.parentElement) {
                                    document.getElementById('containerDiv').parentElement.classList.add(classes.scrollBorder);
                                }
                            }
                        }}
                    >
                    </Waypoint>
                }
                {/* {
                    lastContent && <Waypoint
                        onEnter={({ previousPosition, currentPosition, event }) => {
                            console.log(currentPosition);
                            setTimeout(() => {
                                if (loader && document.getElementById('containerDiv') && document.getElementById('containerDiv')?.parentElement) {
                                    document.getElementById('containerDiv').parentElement.classList.remove(classes.scrollBorder);
                                }
                            }, 500)

                        }}
                        onLeave={({ previousPosition, currentPosition, event }) => {
                            console.log(currentPosition);
                            setTimeout(() => {
                                if (loader && document.getElementById('containerDiv') && document.getElementById('containerDiv')?.parentElement) {
                                    document.getElementById('containerDiv').parentElement.classList.remove(classes.scrollBorder);
                                }
                            }, 500)
                        }}
                    >
                    </Waypoint>
                } */}
            </div>
        </React.Fragment>
    )
});